module.exports = __webpack_public_path__ + "img/contact_ana_message.bb29cfa1.png";